// export interface ItemOptions {
// overlay?: {
//   hoveringBehavior?: string;
// };
// video?: {
//   playTrigger?: string;
// };
// secondaryMedia?: {
//   trigger?: string;
// };
// }
// export interface BehaviorsParams {
//   item?: ItemOptions;
// }

export let GapUnits = /*#__PURE__*/function (GapUnits) {
  GapUnits["px"] = "px";
  GapUnits["vw"] = "vw";
  GapUnits["vh"] = "vh";
  return GapUnits;
}({});
//# sourceMappingURL=galleryTypes.js.map